export const SET_RUNTIME_VARIABLE = 'SET_RUNTIME_VARIABLE';

export const setRuntimeVariable = ({ name, value }) => ({
  type: SET_RUNTIME_VARIABLE,
  payload: {
    name,
    value,
  },
});
